import { useMemo } from 'react';
import Text from 'components/design-system/Text/Text';
import { DICTONARY } from 'const/Dictonary';
import { Dashboard, Event } from '@mui/icons-material';
import { TooltipComponent } from 'components/design-system/Tooltip/Tooltip';
import { formatoFecha } from 'helpers/formatFecha';
import { numeroBaseDatosAFront } from 'helpers/formateoNumeros';

export const useColumnTableEmpresa = () => {
  const empresaColumnTable = useMemo(
    () => [
      {
        header: 'Código',
        accessorKey: 'codigoTransaccion',
        Cell: ({ renderedCellValue }) => <Text>{renderedCellValue}</Text>,
        size: 50
      },
      {
        header: 'Generador',
        accessorKey: 'infoOferente',
        Cell: ({ renderedCellValue }) => (
          <>
            <Text className="text-black">{renderedCellValue.nombre}</Text>
            <Text>{renderedCellValue.direccion} </Text>
          </>
        )
      },
      {
        header: 'Materia transaccionada',
        accessorKey: 'residuo',
        size: 260,
        Cell: ({ renderedCellValue }) => (
          <>
            <Text className="text-black">
              <TooltipComponent>
                {renderedCellValue.tipoResiduo.nombreTipo || ''}
              </TooltipComponent>
            </Text>
            <Text size="S" className="mb-1.5 text-neutral-30">
              <TooltipComponent arrow title="Nombre de recurso">
                {renderedCellValue.nombreRecurso || ''}
              </TooltipComponent>
            </Text>
            <Text className="mb-1.5">
              <TooltipComponent title="Peso y unidad de medida">
                <Dashboard className="text-uv-secondary-0 mr-1" />
                {numeroBaseDatosAFront(renderedCellValue.cantidad) || ''}{' '}
                {renderedCellValue.unidad || ''}{' '}
                {renderedCellValue.unidadMedida?.nombreUnidadMedida || ''}
              </TooltipComponent>
            </Text>
            <Text>
              <TooltipComponent size="S" title="Fecha de disponibilidad">
                <Event className="text-uv-secondary-0 mr-1" />
                {formatoFecha(renderedCellValue.fechaDisponibilidad)}
              </TooltipComponent>
            </Text>
          </>
        )
      },
      {
        header: 'Receptor',
        accessorKey: 'infoDemandante',
        Cell: ({ renderedCellValue }) => (
          <>
            <Text className="text-black">{renderedCellValue.nombre}</Text>
            <Text>{renderedCellValue.direccion}</Text>
          </>
        )
      },
      {
        header: 'Estado',
        accessorKey: 'ultimaTrasaccion',
        Cell: ({ renderedCellValue }) => (
          <>
            <TooltipComponent arrow title={renderedCellValue.nombreEstado}>
              <img
                src={
                  DICTONARY.ESTADOS_TRANSACCION[renderedCellValue.codigoEstado]
                    .ICONO
                }
                alt={renderedCellValue}
              />
            </TooltipComponent>
          </>
        )
      }
    ],
    []
  );

  return empresaColumnTable;
};
